import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";
import { IPermission } from "../model/interface/permission";

export const createPermission = (permission: IPermission) => {
  return AxiosHelper.axiosInstance().post(
    `${APIConstant.CMS_PERMISSION}`,
    permission,
    {}
  );
};

export const updatePermission = (permission: IPermission) => {
  return AxiosHelper.axiosInstance().put(
    `${APIConstant.CMS_PERMISSION}`,
    permission,
    {}
  );
};

export const getPermissions = (
  pageNumber: number,
  pageSize: number,
  sortBy?: string,
  orderByColumn?: string,
  name?: string
) => {
  return AxiosHelper.axiosInstance().get(`${APIConstant.CMS_PERMISSION}`, {
    params: {
      pageNumber: pageNumber,
      pageSize: pageSize,
      SortDir: sortBy,
      OrderByColumn: orderByColumn,
      name: name,
    },
  });
};

export const getPermissionById = (permissionId: number) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_PERMISSION_BY_ID}`,
    {
      params: {
        PermissionId: permissionId,
      },
    }
  );
};
export const deletePermission = (permissionId: number) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_PERMISSION, {
    params: {
      PermissionId: permissionId,
    },
  });
};
